// Tiny helper so role→landing-page logic stays consistent across Login + ProtectedRoute.
export const AUDIT_ROLES = ["audit_team", "audit_partner"];
export const CLIENT_ROLES = ["client", "client_founder"];

export function isAuditRole(role) {
  return AUDIT_ROLES.includes(role);
}

export function isClientRole(role) {
  return CLIENT_ROLES.includes(role);
}

export function defaultRouteFor(user) {
  if (!user) return "/login";
  switch (user.role) {
    case "audit_team":
      return "/audit/dashboard";
    case "audit_partner":
      return "/audit/partner";
    case "client_founder":
      return "/client/founder";
    case "client":
    default:
      return "/client/dashboard";
  }
}
